module.exports = __webpack_public_path__ + "static/media/swimwear.37ea32f9.svg";